import React from "react";

import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import BannerDetailsForm from "../BannerDetailsForm";
import { BANNER_DETAILS_ACTIONS } from "../constants";

const BannerCreateForm = () => {
  const allActions = MenuActionsMappings[MenuNames.DRIVER_BANNER];

  return (
    <BannerDetailsForm
      bannerDetails={{}}
      userAction={BANNER_DETAILS_ACTIONS.CREATE}
    />
  );
};

export default BannerCreateForm;
